import React from 'react'
import { GroupSvgIcon } from '../../constants/common-svgs'

export default function GroupIconSvg() {
  return (
    <div> {GroupSvgIcon}</div>
  )
}
